import React from 'react';
import { useRecordContext } from 'react-admin';

import DiscontinueDialog from "./discontinueSponsershipDialog";
import Card from "@mui/material/Card";
import moment from "moment";
import LetterIcon from "@mui/icons-material/ReceiptOutlined";
import AuthenticatedFileLink from "../uiComponents/AuthenticatedFileLink";
// import DateField from '@mui/material/';


const RecordActions = ({ source, record: recordProp }) => {
  const recordFromContext = useRecordContext();
  const record = recordProp || recordFromContext;


    return (
        <Card style={{marginTop:50}}>
            {/*Status*/}
            {/*<RadioGroup*/}
            {/*    className="select-all"*/}
            {/*    color="primary"*/}

            {/*/>*/}
            {record.status!=="Discontinued"&&<DiscontinueDialog record={record}/>}
            {record.status==="Discontinued"&&record.exitInfo&&<div>
                Discontinued on <strong>{moment(record.exitInfo.date).format('MMMM DD, YYYY')} </strong> <br/>
                Reason <strong>{record.exitInfo.reason}</strong><br/>
                {record.exitInfo.remark} <br/>
                <LetterIcon/>Leave Letter <AuthenticatedFileLink path={record.exitInfo.leaveLetter}/>


            </div>}


        </Card>
    );
};

export default RecordActions;
